import { useCurrentTimeLine } from '../hooks';

import type { FC } from 'react';
import '../styles/CurrentTimeLine.scss';

interface CurrentTimeLineProps {
  startTime: string;
  isToday: boolean;
  intervalHeightPx: number;
}

export const CurrentTimeLine: FC<CurrentTimeLineProps> = ({
  startTime,
  isToday,
  intervalHeightPx,
}) => {
  const { topPx, currentTimeLabel } = useCurrentTimeLine({
    startTime,
    isToday,
    intervalHeightPx,
  });

  if (!isToday) {
    return null;
  }

  return (
    <div
      className="CurrentTimeLine"
      style={{ top: topPx }}
      data-testid="current-time-line"
    >
      <div className="CurrentTimeLine__marker">
        <span className="CurrentTimeLine__time">{currentTimeLabel}</span>
      </div>
      <div className="CurrentTimeLine__line" />
    </div>
  );
};
